module.exports = __webpack_public_path__ + "static/blastFoam_User_Guide-c09d6c02353f2ecaf5d0aa59616990e5.pdf";